import React from "react";
import { ScopeSelect } from "./ScopeSelect";
import { Search, X } from "lucide-react";

export const LB_BRANCHES = [
  { id: "all", zh: "全部分公司", en: "All branches" },
  { id: "la", zh: "洛杉矶", en: "Los Angeles" },
  { id: "norcal", zh: "北加州", en: "NorCal" },
  { id: "sd", zh: "圣地亚哥", en: "San Diego" },
];
export const LB_TEAM_REGION = { team_norcal: "norcal", team_1: "la", team_2: "la", team_3: "sd", team_sd: "sd" };
export const LB_DEFAULT = { q: "", branch: "all", status: "all", sort: "signed" };

const sel = "h-8 rounded-lg border border-slate-200 bg-white px-2 text-xs text-slate-700";

export default function LeaderboardFilters({ f, setF, zh, shown, total }) {
  const dirty = f.q || f.branch !== "all" || f.status !== "all" || f.sort !== "signed";
  return (
    <div className="flex flex-wrap items-center gap-2 px-5 py-2 border-b border-slate-100 bg-slate-50/60" data-testid="leaderboard-filters">
      <label className="relative">
        <Search className="h-3.5 w-3.5 text-slate-400 absolute left-2 top-1/2 -translate-y-1/2" />
        <input data-testid="leaderboard-filter-name" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} placeholder={zh ? "搜索销售姓名" : "Search salesperson"} className={`${sel} pl-7 w-40`} />
      </label>
      <ScopeSelect kind="region" data-testid="leaderboard-filter-branch" value={f.branch} onChange={(e) => setF((p) => (p.branch === e.target.value ? p : { ...p, branch: e.target.value }))} className={sel}>
        {LB_BRANCHES.map((b) => <option key={b.id} value={b.id}>{zh ? b.zh : b.en}</option>)}
      </ScopeSelect>
      <select data-testid="leaderboard-filter-status" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} className={sel}>
        <option value="all">{zh ? "全部达成状态" : "All statuses"}</option>
        <option value="behind">{zh ? "仅未达标" : "Behind target"}</option>
        <option value="ontrack">{zh ? "仅达标" : "On target"}</option>
        <option value="notarget">{zh ? "未设目标" : "No target set"}</option>
      </select>
      <select data-testid="leaderboard-filter-sort" value={f.sort} onChange={(e) => setF({ ...f, sort: e.target.value })} className={sel}>
        <option value="signed">{zh ? "按签单额" : "By signed"}</option>
        <option value="collected">{zh ? "按回款额" : "By collected"}</option>
        <option value="rate">{zh ? "按回款率" : "By collect rate"}</option>
        <option value="monthSigned">{zh ? "按本月签单" : "By month signed"}</option>
      </select>
      <span className="text-xs text-slate-400 ml-auto" data-testid="leaderboard-filter-count">{zh ? `显示 ${shown} / ${total} 人` : `${shown} / ${total} shown`}</span>
      {dirty && (
        <button type="button" data-testid="leaderboard-filter-clear" onClick={() => setF(LB_DEFAULT)} className="inline-flex items-center gap-0.5 text-xs text-slate-500 hover:text-red-600">
          <X className="h-3.5 w-3.5" />{zh ? "清除" : "Clear"}
        </button>
      )}
    </div>
  );
}
